/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { MPlugins, mj } from 'js/entry/util.js';
import { $ } from 'js/entry/base.js';

import { Lightbox } from 'js/entry/media.js';

import { queryCachedInquirerVoting } from './inquirer_voting.js';


/**
 * add votings-related status info to lightbox view
 */
MPlugins.register( [$,mj], 'ui-votings-lightbox-view-hooks', function($,mj) {

	/**
	 *
	 */
	class MediaLightboxItemViewPlugin {

		constructor( voting_id, lb_object_data ) {
			this.voting_id = voting_id;
			this.lb_object_data = lb_object_data;
		}

		toggleLightboxActions( lightbox_id, menu ) {
			var user_is_owner_of_lb = mj.user_id == this.lb_object_data.owner_id;

			var toggle_selector_str = '#media-ctxm-lb-edit,#media-ctxm-lb-delete,#media-ctxm-lb-share';
			if( !user_is_owner_of_lb ) {
				// also disable "send" action - this could be confusing otherwise
				toggle_selector_str += ',#media-ctxm-lb-send';
			}
			$(toggle_selector_str, menu).addClass('disabled');

			if( user_is_owner_of_lb ) {
				queryCachedInquirerVoting(
					this.voting_id,
					// success_cb:
					(inquirer_voting) => {
						if( inquirer_voting.hasFinalVotesSubmitted() ) {
							// re-enable delete
							$('#media-ctxm-lb-delete', menu).removeClass('disabled');
						}
					},
					// error_cb:
					(jqXHR,textStatus,message) => {
						if( jqXHR.responseJSON && jqXHR.responseJSON.error==='Manja\\Ext\\UI\\Votings\\mjInvalidVotingRequestedError' ) {
							// temporarily enable delete action, so user can remove badly associated (lightbox vs voting) data
							$('#media-ctxm-lb-delete', menu).removeClass('disabled');
						}
					}
				);
			}
		}

		afterSetActiveLightbox( lightbox_id ) {
			const od_lightbox_id = this.lb_object_data.list_id;
			if( lightbox_id===od_lightbox_id ) {
				Lightbox.setLocked(lightbox_id,true);
			}
		}

		// beforeUpdateSmallView( mv_open, mls_elem ) {
		// 	// // eslint-disable-next-line
		// 	// console.log( {
		// 	// 	fn: 'beforeUpdateSmallView',
		// 	// 	mv_open,
		// 	// 	mls_elem,
		// 	// 	voting_id: this.voting_id,
		// 	// 	lb_object_data: this.lb_object_data
		// 	// } );
		// 	if( mls_elem ) mls_elem.addClass('votings');
		// }

		// afterUpdateSmallView( mv_open, mls_elem ) {
		// 	// eslint-disable-next-line
		// 	console.log( {
		// 		fn: 'afterUpdateSmallView',
		// 		mv_open,
		// 		mls_elem,
		// 		voting_id: this.voting_id,
		// 		lb_object_data: this.lb_object_data
		// 	} );
		// 	mls_elem.addClass('votings');
		// // }

		// getViewOptions( initial, list_id_explicitely_requested ) {
		// 	if( initial ) {
		// 		//if( list_id_explicitely_requested ) return [true,true];
		// 		return [false,false];
		// 	}
		// 	return [
		// 		true,		// skip small view
		// 		true		// close small view
		// 	];
		// }
	}


	return {
		type: 'MediaLightboxView',

		createItemPlugin: function( group_type, voting_id, lb_object_data, on_item_plugin_created ) {
			if( group_type!=='ui_votings' ) return false; // we are not responsible

			// eslint-disable-next-line
			// console.log({ plugin:'ui-votings-lightbox-view-hooks', fn:'createItemPlugin', group_type, voting_id, lb_object_data, on_item_plugin_created });

			var itemPlugin = new MediaLightboxItemViewPlugin(voting_id,lb_object_data);
			if( on_item_plugin_created ) on_item_plugin_created.call(itemPlugin);
			return true;
		},

	};
} );
